import styled from '../../../theme'


export const DatePickerDrawerText = styled.span`
  color: #696a6d;
  font-weight: bold;
`
export const DatePickerDrawerFooter = styled.div`
  padding: 16px 16px 16px;
`

export const DateRangePickerWidgetContainer = styled.div`
  &
    .CalendarMonthGrid__horizontal
    .CalendarMonthGrid_month__horizontal
    .yearPicker {
    padding-right: 50px;
  }

  &
    .CalendarMonthGrid__horizontal
    .CalendarMonthGrid_month__hidden
    + .CalendarMonthGrid_month__horizontal:not(.CalendarMonthGrid_month__hidden)
    .yearPicker {
    padding-left: 50px;
    padding-right: 0;
  }
`
